import { callApi } from '@/api/apibase'

export const getGreenCourseSettingPages = function () {
  return callApi('GET', `/api/external/greencourse/getSettingPages`, null)
}
